import { call, put } from 'redux-saga/effects';

import { profileAsync } from '../services/userServices';

import {
  userEntitiesSave,
  userModules,
  userModulesSave,
  userDateSave,
  userProfileSuccess,
} from '../actions/userActions';

export function* entitiesSave({ payload }) {
  const { entities } = payload.entities;
  if (entities) {
    yield put(userEntitiesSave(entities));
  }
}

export function* profile() {
  try {
    const user = yield call(profileAsync);
    console.log("->> ", user) 
    yield put(userProfileSuccess(user));
  } catch (err) {
    console.error(err);
  }
}

export function* dateSave({ payload }) {
  const { date } = payload;
  if (date) {
    yield put(userDateSave(date));
  }
}

export function* modules({ payload }) {
  const { modules } = payload.modules;
  yield put(userModules(modules.values));
}

export function* modulesSave({ payload }) {
  const { modules } = payload.modules;
  yield put(userModulesSave(modules.values));
}

export function* sessionTimeout() {
  yield put(userProfileSuccess({}));
}
